import { render, staticRenderFns } from "./selectList.vue?vue&type=template&id=01060f0b&"
import script from "./selectList.vue?vue&type=script&lang=js&"
export * from "./selectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports